"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVal = void 0;
var flattenArrayOfArrays_1 = require("./utils/flattenArrayOfArrays");
/**
 *
 * @param {*} data
 * @param {*} valuePath
 * @returns
 * - if target value is an array found inside an array, it will flatten them out so that there is a single array
 * - if target value is an array NOT found inside an array, that will be returned as is.
 * - if target value is a string/object/number/boolean found inside an array of arrays, then the inner arrays will be flattened so that there is a single array
 * - if target value is a string/object/number/boolean NOT found inside an array, it will be returned as is.
 */
var getVal = function (data, valuePath, options, depthIdx) {
    if (options === void 0) { options = {}; }
    if (depthIdx === void 0) { depthIdx = 0; }
    var value = null;
    var getFinalVal = function (data, valuePath, options, depthIdx) {
        /**
         * sometimes the data passed only is an array,
         * especially via table config this happens.
         */
        return Array.isArray(data)
            ? data.map(function (R) { return getValV2_getter(R, valuePath, options, depthIdx); })
            : getValV2_getter(data, valuePath, options, depthIdx);
    };
    if (Array.isArray(valuePath)) {
        for (var i = 0; i < valuePath.length; i++) {
            value = getFinalVal(data, valuePath[i], options, depthIdx);
            if (value)
                break;
        }
    }
    else {
        value = getFinalVal(data, valuePath, options, depthIdx);
    }
    return value;
};
exports.getVal = getVal;
var getValV2_getter = function (data, valuePath, options, depthIdx) {
    /**
     * if final value is an array inside of an array, (check out CASE 3 sample obj in getVal_caseExamples.js)
     * then flatten.. = true means we get one single returned array
     * else if flatten.. = false means we get an array inside of an array
     */
    var _a = options.flattenIfValueIsArray, flattenIfValueIsArray = _a === void 0 ? true : _a; //have to default to true, to not break older code. ideal would have been if this defaulted to false.
    if (valuePath === null)
        return data;
    var dataRef = data; // a moving reference to internal objects within data
    var keysArray = valuePath.split('.');
    var len = keysArray.length;
    var valIsUndefined = false;
    var thisIterationFoundAry = false;
    var _loop_1 = function (i) {
        var key = keysArray[i];
        if (!thisIterationFoundAry) { // did not find
            if (!dataRef[key]) {
                valIsUndefined = true;
                return "break";
            }
            //else
            dataRef = dataRef[key];
        }
        else { // this iteration found ary. so dataRef is currently an array
            var nestedAryResponse = dataRef.map(function (dataRefItem) {
                var remainingValuePath = keysArray.filter(function (dd, ii) { return ii >= i; }).join('.');
                return (0, exports.getVal)(dataRefItem, remainingValuePath, options, depthIdx + 1);
            });
            return { value: (0, flattenArrayOfArrays_1.flattenArrayOfArrays)({
                    array: nestedAryResponse,
                    flattenLastArray: (depthIdx === 0 && flattenIfValueIsArray === false)
                        ? false
                        : true
                }) };
        }
        if (Array.isArray(dataRef) &&
            Number.isNaN(parseInt(keysArray[i + 1]))
        //because if it is, an explicit call is being made to a particular index in array
        //so dont do our ary magic. the requester knows exactly what they want.
        )
            thisIterationFoundAry = true;
    };
    for (var i = 0; i < len - 1; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
        if (state_1 === "break")
            break;
    }
    if (valIsUndefined)
        return undefined; //if the loop above is broken because we didnt find anything at one of the keys, then return undefined;
    //else
    if (thisIterationFoundAry) { // e.g [ { lastKey: 'xx' }, { lastKey: 'yy' } ] => returned => ['xx', 'yy']
        var toReturn = dataRef.map(function (d) { return d[keysArray[len - 1]]; });
        return (0, flattenArrayOfArrays_1.flattenArrayOfArrays)({
            array: toReturn,
            flattenLastArray: flattenIfValueIsArray
        });
    }
    return dataRef[keysArray[len - 1]];
};
